"use client"

import { Settings } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ThemeSelector } from "@/components/shared/theme-selector"
import { useTheme } from "next-themes"

export function SettingsMenu() {
  const { theme, setTheme } = useTheme()

  const themes = [
    { label: "Светлая", value: "light" },
    { label: "Темная", value: "dark" },
    { label: "Системная", value: "system" },
  ]
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Settings className="h-4 w-4" />
          <span className="sr-only">Открыть настройки</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Настройки</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        <DropdownMenuGroup>
          <DropdownMenuLabel className="text-xs font-normal text-muted-foreground px-2 py-1.5">
            Цветовая тема
          </DropdownMenuLabel>
          {themes.map((item) => (
            <DropdownMenuItem
              key={item.value}
              onClick={() => setTheme(item.value)}
              className="flex items-center cursor-pointer"
            >
              <span>{item.label}</span>
              {theme === item.value && (
                <span className="ml-auto text-xs text-primary">✓</span>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        
        <DropdownMenuSeparator />
        
        {/* Placeholder for future settings */}
        {/* <DropdownMenuGroup>
          <DropdownMenuLabel className="text-xs font-normal text-muted-foreground px-2 py-1.5">
            Дополнительно
          </DropdownMenuLabel>
          <DropdownMenuItem disabled>
            Язык интерфейса
          </DropdownMenuItem>
          <DropdownMenuItem disabled>
            Уведомления
          </DropdownMenuItem>
        </DropdownMenuGroup> */}
      </DropdownMenuContent>
    </DropdownMenu>
  )
} 